import { fromPromise } from 'xstate';
import { MOCK_SCENE } from '../mocks/mock-scene';
import { ActiveScene, StudioPermissions, PrepareSceneInput, PrepareSceneOutput } from './studio.types';


// NOTE: In the app, this actor should be replaced via .provide() to use the real Supabase client
export const prepareSceneActor = fromPromise<PrepareSceneOutput, PrepareSceneInput>(async ({ input }) => {

  if (input.sceneId === 'restricted-scene' && input.userRole === 'viewer') {
    throw new Error('403: Unauthorized');
  }

  await new Promise(resolve => setTimeout(resolve, 500)); 
  
  const scene: ActiveScene = {
    ...MOCK_SCENE,
    id: input.sceneId,
    data: {
      ...MOCK_SCENE.data,
      scene_id: input.sceneId
    }
  };

  const isOwner = scene.ownerId === input.userId;
  const isAdmin = input.userRole === 'admin';

  const permissions: StudioPermissions = {
    canEdit: isAdmin || isOwner, 
    canSave: isAdmin || isOwner,
  };

  return { ...scene, permissions };
});
